import React from 'react';

import classnames from 'classnames';

import 'css/components/inputs/_RadioButton.scss';

type Props = {
  className?: string;
  disabled?: boolean;
  label?: React.ReactNode;
  name: string;
  onSelected: () => void;
  selected?: boolean;
};

const RadioButton = ({ className, disabled, label, name, onSelected, selected = false }: Props) => {
  return (
    <button
      aria-checked={selected}
      aria-label={name}
      className="radioButtonInput"
      disabled={disabled}
      onClick={onSelected}
      role="radio">
      <div className={classnames(className, 'radioButton', { selected })}>
        <div className="selectedDot" />
      </div>
      {label && <div className="radioButtonLabel">{label}</div>}
    </button>
  );
};

export default RadioButton;
